var QuizContainer = (() => {
	var closeModal = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		modal.classList.remove('open');
		pauseVideo(container);
	}
	var openModal = (container, modalNumber) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		modal.classList.add('open');
		modal.setAttribute('data-modal-number', modalNumber);
	}
	var pauseVideo = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		modal.querySelectorAll('[js-modal-video] video').forEach(video => {
			video.pause();
		});
		const videoWrapper = modal.querySelector('[js-modal-video-wrapper]');
		if (videoWrapper) videoWrapper.classList.remove('playing');
	}
	var playVideo = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		const modalNumber = modal.getAttribute('data-modal-number');
		const video = modal.querySelector(`[js-modal-video][data-number="${modalNumber}"] video`);
		if (!video) return;
		video.play();
		const videoWrapper = modal.querySelector('[js-modal-video-wrapper]');
		if (videoWrapper) videoWrapper.classList.add('playing');
	}
	var back = (container) => {
		if (!container) {
			console.log('[quiz-container] issue');
			return;
		}
		container.setAttribute('data-value', container.getAttribute('data-value').slice(0, container.getAttribute('data-value').lastIndexOf('-')));
	}
	var initBackButtons = (container) => {
		if (!container) {
			console.log('[quiz-container] issue');
			return;
		}
		container.querySelectorAll('[js-back]').forEach(element => {
			element.addEventListener('click', () => {
				back(container);
			});
		});
	}
	var initOptions = (container) => {
		container.querySelectorAll('[js-option]').forEach(option => {
			option.addEventListener('click', () => {
				var value = option.getAttribute('data-value');
				const stateWrapper = option.closest('[js-state-wrapper]');
				if (!stateWrapper) {
					console.log('[js-state-wrapper] issue');
					return;
				}
				const checkbox = stateWrapper.querySelector('[js-checkbox]');
				if (checkbox) {
					value = value + checkbox.getAttribute('data-value');
				}
				if (container.getAttribute('data-value') != '') {
					value = container.getAttribute('data-value') + '-' + value;
				}
				container.setAttribute('data-value', value);
				localStorage.setItem('quiz-data-value', value);
			});
		});
	}
	var initCheckbox = (container) => {
		container.querySelectorAll('[js-checkbox-option]').forEach(element => {
			element.addEventListener('click', () => {
				const checkbox = element.closest('[js-checkbox]');
				if (!checkbox) {
					console.log('[js-checkbox] issue');
					return;
				}
				checkbox.setAttribute('data-value', element.getAttribute('data-value'));
			});
		});
		container.querySelectorAll('[js-checkbox-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const checkbox = element.closest('[js-checkbox]');
				if (!checkbox) {
					console.log('[js-checkbox] issue');
					return;
				}
				if (checkbox.getAttribute('data-value') == '1') {
					checkbox.setAttribute('data-value', '2');
				} else {
					checkbox.setAttribute('data-value', '1');
				}
			});
		});
	}
	var initChooseButtons = (container) => {
		container.querySelectorAll('[js-choose-button]').forEach(element => {
			element.classList.remove('chosen');
		});
		fetch('/cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		.then(response => response.json())
		.then(cart => {
			cart.items.forEach(item => {
				container.querySelectorAll('[js-choose-button]').forEach(element => {
					let dataProductIds = element.getAttribute('data-product-ids');
					if (dataProductIds && dataProductIds != '') {
						const productIds = dataProductIds.split(',');
						productIds.forEach(productId => {
							if (String(item.product_id) == String(productId)) {
								element.classList.add('chosen');
                                const smallOptions = element.closest('.small-options');
								if (smallOptions) {
									let all_chosen = true;
									smallOptions.querySelectorAll('.small-option:has([js-choose-button]):not(:has(.optional-badge))').forEach(smallOption => {
										if (smallOption.querySelector('[js-choose-button]').classList.contains('chosen') == false) {
											all_chosen = false;
										}
									});
									if (all_chosen) {
										smallOptions.querySelectorAll('.small-option:has(.optional-badge) [js-choose-button]').forEach(button => {
											button.classList.add('chosen');
										});
									}
								}
							}
						});
					}
				});
			});
		})
		.catch(error => {
			console.error('Error fetching cart:', error);
		});
	}
	var initState = (container) => {
		let value = localStorage.getItem('quiz-data-value');

		if (value) {
			container.setAttribute('data-value', value);
		}

		initChooseButtons(container);
	}
	var initFooterDescriptionTrigger = (container) => {
		if (!container) return;
		container.querySelectorAll('[js-video-modal-trigger').forEach(element => {
			element.addEventListener('click', () => {
				openModal(container, element.getAttribute('data-target-modal'));
			});
		});
	}
	var initCloseModalButtons = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		bigcontainer.querySelectorAll('[js-close]').forEach(element => {
			element.addEventListener('click', () => {
				closeModal(container);
			});
		});
	}
	var initVideoButtons = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		bigcontainer.querySelectorAll('[js-modal-video-play]').forEach(element => {
			element.addEventListener('click', () => {
				playVideo(container);
			});
		});
		bigcontainer.querySelectorAll('[js-modal-video-pause]').forEach(element => {
			element.addEventListener('click', () => {
				pauseVideo(container);
			});
		});
		bigcontainer.querySelectorAll('[js-modal-video] video').forEach(video => {
			video.addEventListener('ended', () => {
				playVideo(container);
				pauseVideo(container);
			});
		});
	}
	var initialize = () => {
		document.querySelectorAll('[quiz-container]').forEach(container => {
			initBackButtons(container);
			initOptions(container);
			initCheckbox(container);
			initState(container);
			initFooterDescriptionTrigger(container);
			initCloseModalButtons(container);
			initVideoButtons(container);
		});
	}
	return {
		init: initialize,
		initChooseButtons: initChooseButtons
	}
})();

var MediaGalleryVideoModalApp = (() => {
	var open = (container) => {
		if (!container) return;
		container.classList.add('open');
	}
	var close = (container) => {
		if (!container) return;
		container.classList.remove('open');
		container.querySelectorAll('video:has(+[js-modal-video-button-play])').forEach(video => {
			pause(video.closest('.modal-body'));
			video.currentTime = 0;
		});
		container.querySelectorAll('.modal-body>iframe').forEach(iframe => {
			iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
		});
	}
	var play = (videoWrapper) => {
		if (!videoWrapper) return;
		videoWrapper.classList.add('playing');
		const video = videoWrapper.querySelector('video');
		if (video) video.play();
	}
	var pause = (videoWrapper) => {
		if (!videoWrapper) return;
		videoWrapper.classList.remove('playing');
		const video = videoWrapper.querySelector('video');
		if (video) video.pause();
	}
	var initialize = () => {
		document.querySelectorAll('[js-product-video-modal] [js-close]').forEach(element => {
			element.addEventListener('click', () => {
					close(element.closest('[js-product-video-modal]'));
			});
		});
		document.querySelectorAll('media-gallery [js-product-video-modal-opener]').forEach(element => {
			element.addEventListener('click', () => {
				open(element.closest('media-gallery').querySelector('[js-product-video-modal]'));
			});
		});
		document.querySelectorAll('media-gallery [js-modal-video-button-play]').forEach(playButton => {
			playButton.addEventListener('click', () => {
				console.log('play button was clicked', playButton.closest('.modal-body'));
				play(playButton.closest('.modal-body'));
			});
		});
		document.querySelectorAll('media-gallery [js-modal-video-button-pause]').forEach(pauseButton => {
			pauseButton.addEventListener('click', () => {
				pause(pauseButton.closest('.modal-body'));
			});
		});
		document.querySelectorAll('media-gallery video:has(+[js-modal-video-button-play])').forEach(video => {
			video.addEventListener('ended', () => {
				play(video.closest('.modal-body'));
				pause(video.closest('.modal-body'));
			});
		});
	}
	return {
		init: initialize
	}
})();

var MediaGalleryApp = (() => {
	var updateSliderComponent = (container, data) => {
		const currentPage = data.detail.currentPage;
		if (currentPage == 1) {
			container.classList.add('left-end');
		} else {
			container.classList.remove('left-end');
		}
		if (currentPage == container.querySelectorAll('ul>li').length) {
			container.classList.add('right-end');
		} else {
			container.classList.remove('right-end');
		}
	}
	var updateIndicator = (indicator, sliderComponent, changedData) => {
		if (!indicator || !sliderComponent || !changedData) return;
		const currentPage = changedData.detail.currentPage;
		const totalPages = sliderComponent.querySelectorAll('ul>li').length;
		let left = 0;
		if (currentPage >= 1 && currentPage <= totalPages) {
			left = (currentPage - 1) / totalPages * 100;
		}
		indicator.style.setProperty('--left', left+'%');
	}
	var initialize = () => {
		document.querySelectorAll('media-gallery .media-gallery--indicator').forEach(element => {
			const sliderComponent = element.closest('media-gallery').querySelector('slider-component');
			if (!sliderComponent) return;
			element.style.setProperty('--width', (100.0 / sliderComponent.querySelectorAll('ul>li').length)+'%');
		});
		document.querySelectorAll('media-gallery slider-component').forEach(container => {
			container.addEventListener('slideChanged', (data) => {
				updateSliderComponent(container, data);
				updateIndicator(container.closest('media-gallery').querySelector('.media-gallery--indicator'), container, data);
			});
		});
	}
	return {
		init: initialize
	}
})();

var MhQTYText = (() => {
	let mainElement = null;
	var show = () => {
		if (!mainElement) return;
		mainElement.classList.remove('!tw-hidden');
	}
	var hide = () => {
		if (!mainElement) return;
		mainElement.classList.add('!tw-hidden');
	}
	var formatPrice = (value) => {
		value = Number(value);
		let A = parseInt(value / 100.0);
		let B = parseInt(value % 100.0);
		B = (B<10)?('0'+B):B;
		return `${A},${B}`;
	}
	var update = (value) => {
		value = Number(value);
		const sqvalue = Math.ceil(value * Number(mainElement.getAttribute('data-sqrm-multiplier')));
		const price = formatPrice(Math.ceil(sqvalue * Number(mainElement.getAttribute('data-price')))) + mainElement.getAttribute('data-currency-symbol');
		const comparePrice = formatPrice(Math.ceil(sqvalue * Number(mainElement.getAttribute('data-compare-price')))) + mainElement.getAttribute('data-currency-symbol');
		const infoElement = mainElement.querySelector('.mh-qty-text__pieces-info');
		if (!infoElement) return;
		infoElement.innerHTML = String(infoElement.getAttribute('data-template')).replace('{{ pieces }}', sqvalue);
		const comparePriceElement = mainElement.querySelector('[js-compare-price]');
		const priceElement = mainElement.querySelector('[js-price]');
		if (!comparePriceElement || !priceElement) return;
		comparePriceElement.innerHTML = comparePrice;
		priceElement.innerHTML = price;
	}
	var rerender = () => {
		if (!mainElement) return;
		const specialPricePerPiece = (document.querySelector('[js-data-special-price-per-piece]'))?document.querySelector('[js-data-special-price-per-piece]').getAttribute('data-value'):0;
		const comparePricePerPiece = (document.querySelector('[js-data-compare-price-per-piece]'))?document.querySelector('[js-data-compare-price-per-piece]').getAttribute('data-value'):0;
		const sqrmMultiplier = (document.querySelector('[js-data-sqrm-multiplier]'))?document.querySelector('[js-data-sqrm-multiplier]').getAttribute('data-value'):0;
		mainElement.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
		mainElement.setAttribute('data-other', sqrmMultiplier);
		mainElement.setAttribute('data-price', specialPricePerPiece);
		mainElement.setAttribute('data-compare-price', comparePricePerPiece);
		document.querySelectorAll('.mh-qty-text').forEach(element => {
			element.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
			element.setAttribute('data-other', sqrmMultiplier);
			element.setAttribute('data-price', specialPricePerPiece);
			element.setAttribute('data-compare-price', comparePricePerPiece);
		});
		if (document.querySelector('.quantity--square>input')) {
			update(document.querySelector('.quantity--square>input').getAttribute('data-numb-value'));
		}
	}
	var initialize = () => {
		mainElement = document.querySelector('[js-mh-qty-text]');
		document.querySelectorAll('.mh-qty-switch__label').forEach(element => {
			element.addEventListener('click', () => {
				if (element.getAttribute('data-type') == 'squarem') {
					show();
				} else {
					hide();
				}
			});
		});
		document.querySelectorAll('.quantity--square>input').forEach(element => {
			element.addEventListener('blur', () => {
				update(element.getAttribute('data-numb-value'));
				MhQTYTextFliped.update(Math.ceil(Number(element.getAttribute('data-numb-value')) * Number(mainElement.getAttribute('data-sqrm-multiplier'))))
			});
		});
	}
	return {
		init: initialize,
		update: update,
		rerender: rerender
	}
})();

var MhQTYTextFliped = (() => {
	let mainElement = null;
	var show = () => {
		if (!mainElement) return;
		mainElement.classList.remove('!tw-hidden');
	}
	var hide = () => {
		if (!mainElement) return;
		mainElement.classList.add('!tw-hidden');
	}
	var formatPrice = (value) => {
		value = Number(value);
		let A = parseInt(value / 100.0);
		let B = parseInt(value % 100.0);
		B = (B<10)?('0'+B):B;
		return `${A},${B}`;
	}
	var update = (value) => {
		value = Number(value);
		const sqvalue = parseInt(value / Number(mainElement.getAttribute('data-sqrm-multiplier')) * 100) / 100.0;
		const price = formatPrice(Math.ceil(value * Number(mainElement.getAttribute('data-price')))) + mainElement.getAttribute('data-currency-symbol');
		const comparePrice = formatPrice(Math.ceil(value * Number(mainElement.getAttribute('data-compare-price')))) + mainElement.getAttribute('data-currency-symbol');
		const infoElement = mainElement.querySelector('.mh-qty-text__pieces-info');
		if (!infoElement) return;
		infoElement.innerHTML = String(infoElement.getAttribute('data-template')).replace('{{ pieces }}', sqvalue);
		const comparePriceElement = mainElement.querySelector('[js-compare-price]');
		const priceElement = mainElement.querySelector('[js-price]');
		if (!comparePriceElement || !priceElement) return;
		comparePriceElement.innerHTML = comparePrice;
		priceElement.innerHTML = price;
	}
	var rerender = () => {
		if (!mainElement) return;
		const specialPricePerPiece = (document.querySelector('[js-data-special-price-per-piece]'))?document.querySelector('[js-data-special-price-per-piece]').getAttribute('data-value'):0;
		const comparePricePerPiece = (document.querySelector('[js-data-compare-price-per-piece]'))?document.querySelector('[js-data-compare-price-per-piece]').getAttribute('data-value'):0;
		const sqrmMultiplier = (document.querySelector('[js-data-sqrm-multiplier]'))?document.querySelector('[js-data-sqrm-multiplier]').getAttribute('data-value'):0;
		mainElement.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
		mainElement.setAttribute('data-other', sqrmMultiplier);
		mainElement.setAttribute('data-price', specialPricePerPiece);
		mainElement.setAttribute('data-compare-price', comparePricePerPiece);
		if (document.querySelector('quantity-input>input[name="quantity"]')) {
			update(document.querySelector('quantity-input>input[name="quantity"]').value);
		}
	}
	var initialize = () => {
		mainElement = document.querySelector('[js-mh-qty-text-fliped]');
		document.querySelectorAll('.mh-qty-switch__label').forEach(element => {
			element.addEventListener('click', () => {
				if (element.getAttribute('data-type') == 'piece') {
					show();
				} else {
					hide();
					document.querySelectorAll('quantity-input>input[name="quantity"]').forEach(quantityElement => {
						const updatedValue = Math.ceil(Math.floor(quantityElement.value / Number(mainElement.getAttribute('data-sqrm-multiplier'))) * Number(mainElement.getAttribute('data-sqrm-multiplier')));
						quantityElement.value = updatedValue;
						update(updatedValue);
					});
				}
			});
		});
		document.querySelectorAll('quantity-input>input[name="quantity"]').forEach(element => {
			element.addEventListener('blur', () => {
				update(element.value);
				MhQTYText.update(Math.floor(element.value / Number(mainElement.getAttribute('data-sqrm-multiplier'))));
			});
		});
	}
	return {
		init: initialize,
		update: update,
		rerender: rerender
	}
})();


var MenuDrawerSearchApp = (() => {
	var searchElement = null;
	var open = () => {
		if (!searchElement) return;
		searchElement.classList.add('active');
	}
	var close = () => {
		if (!searchElement) return;
		searchElement.classList.remove('active');
	}
	var initialize = () => {
		searchElement = document.querySelector('[js-menu-drawer-search]');
		document.querySelectorAll('[js-menu-drawer-search-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				open();
			});
		});
		if (searchElement) {
			document.addEventListener('click', (e) => {
				if (!(searchElement && searchElement.contains(e.target)) && !(document.querySelector('[js-menu-drawer-search-trigger]') && document.querySelector('[js-menu-drawer-search-trigger]').contains(e.target))) {
					close();
				}
			});
		}
	}
	return {
		init: initialize
	}
})();


class MenuAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('summary+div');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

var SubcategoryModalApp = (() => {
	var open = (modal) => {
		if (!modal) return;
		modal.classList.add('open');
	}

	var close = (modal) => {
		if (!modal) return;
		modal.classList.remove('open');
	}

	var initialize = () => {
		document.querySelectorAll('[js-subcategory-modal-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const container = element.closest('[js-container]');
				if (!container) return;
				open(container.querySelector('[js-subcategory-modal]'));
			});
		});
		document.querySelectorAll('[js-subcategory-modal] [js-close]').forEach(element => {
			element.addEventListener('click', () => {
				close(element.closest('[js-subcategory-modal]'));
			});
		});
	}
	return {
		init: initialize
	}
})();

var SquareSelectorApp = (() => {
  var openModal = (container) => {
    if (!container) return;
    const modal = container.querySelector('[js-modal]');
    if (!modal) return;
    modal.classList.add('open');
		container.classList.remove('d-none');
  }
  var closeModal = (container) => {
    if (!container) return;
    const modal = container.querySelector('[js-modal]');
    if (!modal) return;
    modal.classList.remove('open');
		if (container.closest('quantity-popover') && container.closest('quantity-popover').querySelector('[data-cart-quantity]')) {
			container.closest('quantity-popover').querySelector('[data-cart-quantity]').value = parseInt(container.querySelector('[js-piece-value-wrapper] li.active').innerHTML);
			container.closest('quantity-popover').querySelector('[data-cart-quantity]').setAttribute('data-cart-quantity', parseInt(container.querySelector('[js-piece-value-wrapper] li.active').innerHTML));
			container.closest('quantity-popover').querySelector('[data-cart-quantity]').dispatchEvent(new Event('change', { bubbles: true }));
			return;
		}
    const trigger = container.querySelector('[js-trigger]');
    const selectedValue = container.querySelector('[js-selected-value]');
    if (!trigger || !selectedValue || !container.querySelector('.value-list--wrapper.active li.active')) return;
    trigger.classList.add('selected');
    selectedValue.innerHTML = `${container.querySelector('.value-list--wrapper.active li.active').innerHTML}${(container.querySelector('.square-switch .active')) ? (container.querySelector('.square-switch .active').innerHTML) : ''}`;

		if (container.hasAttribute('no-need-injection') && container.closest('product-info')) {
			container.closest('product-info').querySelectorAll('.square-selector input+label').forEach(element => {
				if (element.getAttribute('data-value') === selectedValue.innerText) {
					element.click();
				}
			});
		}

		const realQuantityElement = document.querySelector('product-info .product-page__qtty-input');
		if (container.hasAttribute('fill-quantity-input') && realQuantityElement) {
			realQuantityElement.value = parseInt(container.querySelector('.value-list--wrapper.active li.active').innerHTML);
		}
  }

  var synchronizeScrollers = (container) => {
    const pieceWrapper = container.querySelector('[js-piece-value-wrapper] .value-list');
    const squareWrapper = container.querySelector('[js-square-value-wrapper] .value-list');
    const realQuantityElement = document.querySelector('product-info .product-page__qtty-input');
    
    if (!pieceWrapper || !squareWrapper || !realQuantityElement) return;
    
    // Synchronization lock to prevent infinite loops
    let isSyncing = false;
    let syncTimeout = null;

    const syncFromPieceToSquare = () => {
      if (isSyncing) return;
      isSyncing = true;
      
      const activePiece = pieceWrapper.querySelector('li.active');
      if (activePiece || !document.querySelector('[data-sqrm-multiplier]')) {
        const sqrmMultiplier = parseFloat(document.querySelector('[data-sqrm-multiplier]').getAttribute('data-sqrm-multiplier'));
        const pieceValue = parseInt(activePiece.textContent);
        const squareValue = Math.floor(pieceValue / sqrmMultiplier);
        const squareItems = squareWrapper.querySelectorAll('li');
        squareItems.forEach(item => item.classList.remove('active'));
        
        const targetSquareItem = Array.from(squareItems).find(item => 
          parseInt(item.textContent) === squareValue
        );

        if (targetSquareItem) {
          targetSquareItem.classList.add('active');
          squareWrapper.scrollTo({
            top: targetSquareItem.offsetTop - squareWrapper.clientHeight / 2 + targetSquareItem.offsetHeight / 2,
            behavior: 'auto'
          });
        }
        realQuantityElement.value = pieceValue;
        console.log('here is the pieceValue 1', pieceValue);
      }
      
      // Release the lock after a delay
      setTimeout(() => {
        isSyncing = false;
      }, 500);
    };

    const syncFromSquareToPiece = () => {
      if (isSyncing) return;
      isSyncing = true;
      
      const activeSquare = squareWrapper.querySelector('li.active');
      if (activeSquare || !document.querySelector('[data-sqrm-multiplier]')) {
        const sqrmMultiplier = parseFloat(document.querySelector('[data-sqrm-multiplier]').getAttribute('data-sqrm-multiplier'));
        const squareValue = parseInt(activeSquare.textContent);
        const pieceValue = Math.ceil(squareValue * sqrmMultiplier);
        
        const pieceItems = pieceWrapper.querySelectorAll('li');
        pieceItems.forEach(item => item.classList.remove('active'));
        
        const targetPieceItem = Array.from(pieceItems).find(item => 
          parseInt(item.textContent) === pieceValue
        );
        
        if (targetPieceItem) {
          targetPieceItem.classList.add('active');
          pieceWrapper.scrollTo({
            top: targetPieceItem.offsetTop - pieceWrapper.clientHeight / 2 + targetPieceItem.offsetHeight / 2,
            behavior: 'auto'
          });
        }

        realQuantityElement.value = pieceValue;
        console.log('here is the pieceValue 2', pieceValue);
      }
      
      // Release the lock after a delay
      setTimeout(() => {
        isSyncing = false;
      }, 500);
    };

    pieceWrapper.addEventListener('scroll', () => {
      if (isSyncing) return; // Don't sync if we're already syncing
      
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(() => {
        syncFromPieceToSquare();
      }, 300);
    });

    squareWrapper.addEventListener('scroll', () => {
      if (isSyncing) return; // Don't sync if we're already syncing
      
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(() => {
        syncFromSquareToPiece();
      }, 300);
    });

    return { syncFromPieceToSquare, syncFromSquareToPiece };
  };

  var initEachContainer = (container) => {
    if (!container) return;
    container.addEventListener('click', (e) => {
      if (e.target.closest('li.active')) {
        closeModal(container);
      }
    });
    container.querySelectorAll('[js-trigger]').forEach(element => {
      element.addEventListener('click', () => {
        openModal(container);
      });
    });
    container.querySelectorAll('[js-modal] [js-close]').forEach(element => {
      element.addEventListener('click', () => {
        closeModal(container);
      });
    });
		document.addEventListener('click', (event) => {
			if (event.target.closest('.cart-drawer__overlay')) {
				closeModal(container);
			}
		});
    container.querySelectorAll('[js-piece-mode]').forEach(element => {
      element.addEventListener('click', () => {
        container.querySelectorAll('[js-piece-value-wrapper], [js-piece-mode]').forEach(wrapper => {
          wrapper.classList.add('active');
        });
        container.querySelectorAll('[js-square-value-wrapper], [js-square-mode]').forEach(wrapper => {
          wrapper.classList.remove('active');
        });
      });
    });
    container.querySelectorAll('[js-square-mode]').forEach(element => {
      element.addEventListener('click', () => {
        container.querySelectorAll('[js-square-value-wrapper], [js-square-mode]').forEach(wrapper => {
          wrapper.classList.add('active');
        });
        container.querySelectorAll('[js-piece-value-wrapper], [js-piece-mode]').forEach(wrapper => {
          wrapper.classList.remove('active');
        });
      });
    });

    container.querySelectorAll('.value-list').forEach((picker, index) => {
      const ul = picker.querySelector('ul');
      if (!ul) return;
      const MIN = 1, MAX = 500;
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;

			if (!container.hasAttribute('no-need-injection')) {
				for (let i = MIN; i <= MAX; i++) {
					const li = document.createElement('li');
					li.textContent = i;
					ul.appendChild(li);
				}
			}

      function updateActive() {
        const items = ul.querySelectorAll('li');
        const centerY = picker.scrollTop + picker.clientHeight / 2;
        let closest = null, best = Infinity;
        items.forEach(li => {
          const liCenter = li.offsetTop + li.offsetHeight / 2;
          const dist = Math.abs(centerY - liCenter);
          li.classList.remove('active');
          if (dist < best) { best = dist; closest = li; }
        });
        if (closest) closest.classList.add('active');
      }

      picker.addEventListener('scroll', updateActive);

      let scrollTimeout;
      function snapToActive() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const active = ul.querySelector('li.active');
          if (active) {
            picker.scrollTo({
              top: active.offsetTop - picker.clientHeight / 2 + active.offsetHeight / 2,
              behavior: 'smooth'
            });
          }
        }, 120);
      }
      picker.addEventListener('scroll', snapToActive);

      ul.addEventListener('click', (e) => {
        if (e.target.tagName === 'LI') {
          e.preventDefault();
          e.stopPropagation();
          
          ul.querySelectorAll('li').forEach(item => item.classList.remove('active'));
          
          e.target.classList.add('active');
          
          picker.scrollTo({
            top: e.target.offsetTop - picker.clientHeight / 2 + e.target.offsetHeight / 2,
            behavior: 'smooth'
          });
					setTimeout(() => {
						closeModal(container);
					}, 400);
        }
      });

      picker.addEventListener('mousedown', (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = picker.scrollTop;
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const delta = e.clientY - startY;
        picker.scrollTop = startScrollTop - delta; // reverse direction for natural feel
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          snapToActive();
        }
      });

      if (index === 0) {
        let initial = 5;
				if (container.closest('.cart-item') && container.closest('.cart-item').querySelector('[data-cart-quantity]')) {
					initial = parseInt(container.closest('.cart-item').querySelector('[data-cart-quantity]').value);
				}
        const idx = initial - MIN;
        setTimeout(() => {
          const target = ul.children[idx];
          if (target) {
						target.scrollIntoView({ block: 'center', behavior: 'auto' });
					}
        }, 100);
				if (container.closest('.cart-item')) {
					setTimeout(() => {
						container.classList.add('d-none');
					}, 500);
				}
      }
    });

    setTimeout(() => {
      synchronizeScrollers(container);
    }, 500);

    document.addEventListener('variant:change:end', () => {
      const scrollWrapper = container.querySelector('.value-list--wrapper.active .value-list');
      if (!scrollWrapper) return;
      const scrollTop = scrollWrapper.scrollTop;
      scrollWrapper.scrollTo({top: 0, behavior: 'auto'});
      scrollWrapper.scrollTo({top: scrollTop, behavior: 'auto'});
      const realQuantityElement = document.querySelector('product-info .product-page__qtty-input');
      if (!realQuantityElement) return;
			if (container.querySelector('.value-list--wrapper li.active')) {
				realQuantityElement.value = parseInt(container.querySelector('.value-list--wrapper li.active').innerText);
			}
    });
  }
  var initialize = () => {
    document.querySelectorAll('[js-square-selector]').forEach(container => {
      initEachContainer(container);
    });
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType !== Node.ELEMENT_NODE) return;
						
						if (node.hasAttribute && node.hasAttribute('js-square-selector')) {
							initEachContainer(node);
						}
						
						if (node.querySelectorAll) {
							node.querySelectorAll('[js-square-selector]').forEach(container => {
								initEachContainer(container);
							});
						}
					});
				}
			});
		});
		
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
  }
  return {
    init: initialize
  }
})();

var SaleBannerApp = (() => {
	var initEachContainer = (container) => {
		if (!container || !container.hasAttribute('data-end-date')) return;
		const end_date_time = new Date(container.getAttribute('data-end-date'));
		const interval_id = setInterval(() => {
			const current_date_time = new Date();
			if (current_date_time > end_date_time) {
				container.classList.add('d-none');
				clearInterval(interval_id);
				return;
			}
			container.classList.remove('d-none');
			if (
				current_date_time.getFullYear() === end_date_time.getFullYear() &&
				current_date_time.getMonth() === end_date_time.getMonth() &&
				current_date_time.getDay() === end_date_time.getDay()
			) {
				container.classList.add('last-date');
				return;
			}
			container.classList.remove('last-date');
		}, 1000);
	}
	var initialize = () => {
		document.querySelectorAll('[js-sale-banner]').forEach(container => {
			initEachContainer(container);
		});
	}
	return {
		init: initialize
	}
})();

var App = (() => {
	var initialize = () => {
		QuizContainer.init();
    MediaGalleryApp.init();
		MediaGalleryVideoModalApp.init();
    MhQTYText.init();
		MhQTYTextFliped.init();
    MenuDrawerSearchApp.init();
		SaleBannerApp.init();
		if (document.body.hasAttribute('square-calculator-ab-test')) {
			SquareSelectorApp.init();
		}
		document.querySelectorAll('.menu-drawer__navigation-container details').forEach((el) => {
			new MenuAccordion(el);
		});
    SubcategoryModalApp.init();
	}
	return {
		init: initialize
	}
})();

document.addEventListener('DOMContentLoaded', () => {
	App.init();
});

document.addEventListener('cart-item:quantity-updated', () => {
	document.querySelectorAll('[quiz-container]').forEach(container => {
		QuizContainer.initChooseButtons(container);
	});
});

document.addEventListener('cart:updated', () => {
	document.querySelectorAll('[quiz-container]').forEach(container => {
		QuizContainer.initChooseButtons(container);
	});
});

var updateVariantDiscount = async () => {
	const response = await fetch(window.location.href);
	const html = await response.text();
	const parser = new DOMParser();
	const newDoc = parser.parseFromString(html, 'text/html');
	
	const currentHeading = document.querySelector('product-timer .heading');
	const newHeading = newDoc.querySelector('product-timer .heading');
	if (currentHeading && newHeading) {
		currentHeading.innerHTML = newHeading.innerHTML;
	}

	const currentPrice = document.querySelector('product-timer .discounted-price .price');
	const newPrice = newDoc.querySelector('product-timer .discounted-price .price');
	if (currentPrice && newPrice) {
		currentPrice.innerHTML = newPrice.innerHTML;
	}
}

document.addEventListener('variant:change:end', () => {
	MhQTYText.rerender();
	MhQTYTextFliped.rerender();
	updateVariantDiscount();
});